export default __webpack_public_path__ + "static/media/General's Boots of the Warring States.aca8efcd.jpg";